export default "__VITE_ASSET__RIaDbghP__"